import React from 'react';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router';
import 'App.css';
import Header from 'components/Header';
import AccountSettings from 'pages/AccountSettings';
import GroupDetail from 'pages/GroupDetail';
import EventDetail from 'pages/EventDetail';
import GroupSettings from 'pages/GroupSettings';
import Login from 'pages/Login';
import Register from 'pages/Register';
import Browse from 'pages/Browse';
import EditGroup from 'pages/EditGroup';
import EditEvent from 'pages/EditEvent';
import NewMemberSettings from 'pages/NewMemberSettings';
import { UserProvider } from 'contexts/UserContext';
import EditProfile from 'pages/EditProfile';
import EditMemberProfile from 'pages/EditMemberProfile';
import ViewMemberProfile from 'pages/ViewMemberProfile';
import JoinGroup from 'pages/JoinGroup';
import MemberApplication from 'pages/MemberApplication';

const AuthenticatedLayout = () => {
    return (
        <UserProvider>
            <Outlet />
        </UserProvider>
    );
};

function App() {
  return (
      <BrowserRouter>
      <div className="App">
        <Header />
        <main className="main-content">
          <Routes>
                      <Route path="/login" element={<Login />} />
                      <Route path="/register" element={<Register />} />
                      <Route element={<AuthenticatedLayout />}>
                          <Route path="/" element={<Browse />} />
                          <Route path="/browse-groups" element={<Browse />} />
                          <Route path="/browse-events" element={<Browse />} />
                          <Route path="/account-settings" element={<AccountSettings />} />
                          <Route path="/edit-profile" element={<EditProfile />} />
                          <Route path="/groups/:organizationId/members/me/edit" element={<EditMemberProfile />} />
                          <Route path="/groups/:organizationId/members/:organizationMemberId" element={<ViewMemberProfile />} />
                          <Route path="/groups/:organizationId" element={<GroupDetail />} />
                          <Route path="/events/:eventId" element={<EventDetail />} />
                          <Route path="/groups/:organizationId/settings" element={<GroupSettings />} />
                          <Route path="/groups/new" element={<EditGroup />} />
                          <Route path="/groups/:organizationId/edit" element={<EditGroup />} />
                          <Route path="/groups/:organizationId/events/new" element={<EditEvent />} />
                          <Route path="/events/:eventId/edit" element={<EditEvent />} />
                          <Route path="/groups/:organizationId/member-settings" element={<NewMemberSettings />} />
                          <Route path="/groups/:organizationId/join" element={<JoinGroup />} />
                          <Route path="/groups/:organizationId/applications/:organizationMemberId" element={<MemberApplication />} />  
                      </Route>
          </Routes>
        </main>
      </div>
      </BrowserRouter>
  );
}

export default App;
